import "./App.css";
import "./css/bootstrap.css";
import "./css/responsive.css";
import "./css/style.css";

import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Categories from "./pages/Categories";
import Product from "./pages/Product";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import NoMatch from "./pages/NoMatch";
import InitiateSession from "./pages/InitiateSession";
import { useDispatch, useSelector } from "react-redux";
import ShoppingCart from "./components/ShoppingCart";
import CheckOut from "./pages/CheckOut";
import ThankYou from "./pages/ThankYou";
import MyOrders from "./pages/MyOrders";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import WelcomeModal from "./components/WelcomeModal";
import EditMyInfo from "./pages/EditMyInfo";
import { useEffect } from "react";

function App() {
  const isShoppingCartShowing = useSelector((state) => state.shoppingCart.isShowing);
  const mustLoginRedirect = useSelector((state) => state.shoppingCart.mustRedirect);
  const showWelcomeModal = useSelector((state) => state.welcomeModal);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (location.pathname !== "/login" && location.pathname !== "/register" && mustLoginRedirect) {
      dispatch({ type: "TOGGLE_LOGIN_REDIRECTION" });
    }
  }, [location]);

  return (
    <div className="App">
      {showWelcomeModal && <WelcomeModal />}
      {isShoppingCartShowing && <ShoppingCart />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<InitiateSession />} />
        <Route path="/register" element={<InitiateSession />} />
        <Route path="/categories/:slug" element={<Categories />} />
        <Route path="/product/:slug" element={<Product />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/checkout/:step" element={<CheckOut />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/my-orders" element={<MyOrders />} />
        <Route path="/edit-my-info" element={<EditMyInfo />} />
        <Route path="*" element={<NoMatch />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
      </Routes>
    </div>
  );
}

export default App;
